import { render, staticRenderFns } from "./blockquote.vue?vue&type=template&id=7a690855&functional=true&"
import script from "./blockquote.vue?vue&type=script&lang=js&"
export * from "./blockquote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports